import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../index'
import { onLogout } from '../rootActions'

type RoleState = {
  isAdmin: boolean
  roles: string[]
}

const initialState: RoleState = {
  isAdmin: false,
  roles: [],
}

const roleSlice = createSlice({
  name: 'role',
  initialState: initialState,
  reducers: {
    setAdmin: (state, action: PayloadAction<boolean>) => {
      state.isAdmin = action.payload
    },
    setRoles: (state, action: PayloadAction<string[]>) => {
      state.roles = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(onLogout, () => initialState)
  },
})

export const roleReducer = roleSlice.reducer
export const roleActions = roleSlice.actions

const selectSlice = (state: RootState) => state.role

export const isAdminSelector = createSelector(selectSlice, (roleState) => roleState.isAdmin)
export const loggedUserRolesSelector = createSelector(selectSlice, (roleState) => roleState.roles)
